import React, { useEffect, useRef, useState } from "react";
import { Dialog } from "primereact/dialog";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { useTranslation } from "react-i18next";
import { Toast } from "primereact/toast";
import { FilterMatchMode } from "primereact/api";
import { Dropdown } from "primereact/dropdown";

function AlarmsMetadataDialog({
  measuresMetadata,
  setMeasuresData,
  visible,
  onHide,
}) {
  const { t } = useTranslation();
  const toast = useRef(null);
  const [machineOptions, setMachineOptions] = useState([]);
  const [filters, setFilters] = useState({
    Machine: { value: null, matchMode: FilterMatchMode.EQUALS },
    ID: { value: null, matchMode: FilterMatchMode.CONTAINS },
    Description: { value: null, matchMode: FilterMatchMode.CONTAINS },
  });

  useEffect(() => {
    if (measuresMetadata != null && measuresMetadata.length > 0) {
      const machineOptions = [
        ...new Set(measuresMetadata.map((item) => item.Machine)),
      ].map((machine) => ({ label: machine, value: machine }));
      setMachineOptions(machineOptions);
    }
  }, [visible]);

  const machineFilterTemplate = (options) => {
    return (
      <Dropdown
        value={options.value}
        options={machineOptions}

        onChange={(e) => {
          options.filterCallback(e.value, options.index);
          const newFilters = { ...filters };
          newFilters.Machine.value = e.value;
          setFilters(newFilters);
        }}
        className="p-column-filter"
        showClear
        filter
      />
    );
  };

  return (
    <Dialog
      header={
        <div
          style={{ display: "flex", alignItems: "center", }}
        >
          <i className="pi pi-cog" style={{ marginRight: "0.5rem" }}></i>
          {t("measuresDetails")}
        </div>
      }
      visible={visible}
      onHide={onHide}
      style={{ width: "90%" }}
    >
      <Toast ref={toast} />
      <DataTable
        value={measuresMetadata}
        stripedRows
        paginator
        rows={10}
       
        filters={filters}
        onFilter={(e) => {
          setFilters(e.filters);
        }}
      >
        <Column
          field="Machine"
          header={t("machine")}
          sortable
          filter
          filterElement={machineFilterTemplate}
          showFilterMenu={false}
          filterMatchMode="equals" // ✅ Fix: explicitly define match mode
        />
        <Column field="ID" header={t("id")} sortable filter></Column>
        <Column
          field="Description"
          header={t("Description")}
          sortable
          filter
        ></Column>

        {/*<Column field="Conversion" header={t("scaling")} sortable></Column>*/}
      </DataTable>
    </Dialog>
  );
}

export default AlarmsMetadataDialog;
